import { render, staticRenderFns } from "./LocationEmptyScreen.vue?vue&type=template&id=c532460a&scoped=true&"
import script from "./LocationEmptyScreen.vue?vue&type=script&lang=js&"
export * from "./LocationEmptyScreen.vue?vue&type=script&lang=js&"
import style0 from "./LocationEmptyScreen.vue?vue&type=style&index=0&id=c532460a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c532460a",
  null
  
)

export default component.exports